import React, { useState, useEffect, useCallback } from 'react';
import { Outlet, Link, useNavigate } from 'react-router-dom';
import { useCart } from './CartContext';
import { shopApi } from '../services/api';

const C = { primary: '#D85A30', teal: '#1D9E75', bg: '#F5EFE6', text: '#1a1a1a', muted: '#888', border: '#e0e0e0' };

export function fmt(n) {
  return new Intl.NumberFormat('cs-CZ', { style: 'currency', currency: 'CZK', maximumFractionDigits: 0 }).format(n || 0);
}

export default function ShopLayout() {
  const { items, remove, update, count, subtotal, clear } = useCart();
  const [cartOpen, setCartOpen] = useState(false);
  const [settings, setSettings] = useState({ title: '', tagline: '', shipping_cost: 89, free_shipping: 1500, facebook_url: '', vat_registered: false, vat_rate: 21 });
  const [search, setSearch] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    shopApi.settings().then(setSettings).catch(() => shopApi.config().then(setSettings).catch(() => {}));
  }, []);

  const shipping = subtotal >= settings.free_shipping ? 0 : settings.shipping_cost;
  const total = subtotal + shipping;

  function goCheckout() { setCartOpen(false); navigate('/shop/objednat'); }

  const handleSearch = useCallback((e) => {
    if (e.key === 'Enter' && search.trim()) {
      navigate(`/shop?search=${encodeURIComponent(search.trim())}`);
    }
  }, [search, navigate]);

  return (
    <div style={{ minHeight: '100vh', background: 'white', fontFamily: 'system-ui, -apple-system, sans-serif', color: C.text }}>
      {/* Header fixní */}
      <header style={{ position: 'sticky', top: 0, zIndex: 100, background: 'white', borderBottom: `1px solid ${C.border}`, boxShadow: '0 1px 4px rgba(0,0,0,0.06)' }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', padding: '0 24px', height: 64, display: 'flex', alignItems: 'center', gap: 20 }}>
          {/* Logo */}
          <Link to="/shop" style={{ textDecoration: 'none', flexShrink: 0 }}>
            <img src="/logo.png" height="44" alt={settings.title} style={{ display: 'block' }}
              onError={e => { e.target.style.display='none'; e.target.nextSibling.style.display='block'; }}
            />
            <span style={{ display: 'none', fontWeight: 700, fontSize: 16, color: C.teal }}>{settings.title}</span>
          </Link>

          {/* Vyhledávání */}
          <div style={{ flex: 1, maxWidth: 480, position: 'relative' }}>
            <input
              value={search}
              onChange={e => setSearch(e.target.value)}
              onKeyDown={handleSearch}
              placeholder="Hledat produkty…"
              style={{ width: '100%', padding: '8px 16px 8px 38px', borderRadius: 22, border: `1.5px solid ${C.border}`, fontSize: 14, outline: 'none', boxSizing: 'border-box' }}
            />
            <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', fontSize: 16, color: C.muted }}>🔍</span>
          </div>

          {/* Pravá část */}
          <div style={{ display: 'flex', alignItems: 'center', gap: 16, marginLeft: 'auto' }}>
            {settings.facebook_url && (
              <a href={settings.facebook_url} target="_blank" rel="noreferrer" style={{ color: '#1877F2', fontSize: 22 }} title="Facebook skupina">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="#1877F2"><path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/></svg>
              </a>
            )}
            <Link to="/shop/kosik" style={{ position: 'relative', textDecoration: 'none', color: C.text, fontSize: 22 }} title="Košík">
              🛒
              {count > 0 && (
                <span style={{ position: 'absolute', top: -6, right: -8, background: C.primary, color: 'white', borderRadius: '50%', width: 18, height: 18, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 11, fontWeight: 700 }}>
                  {count > 9 ? '9+' : count}
                </span>
              )}
            </Link>
          </div>
        </div>
      </header>

      {/* Obsah stránky */}
      <div style={{ flex: 1 }}>
        <Outlet context={{ settings, setCartOpen }} />
      </div>

      {/* Footer */}
      <footer style={{ background: '#1a1a1a', color: 'rgba(255,255,255,0.5)', padding: '32px 24px', marginTop: 60, fontSize: 13 }}>
        <div style={{ maxWidth: 1200, margin: '0 auto', display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
          <div>
            <div style={{ color: 'white', fontWeight: 600, fontSize: 15, marginBottom: 6 }}>{settings.title}</div>
            <div>{settings.tagline}</div>
          </div>
          <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
            {settings.facebook_url && <a href={settings.facebook_url} target="_blank" rel="noreferrer" style={{ color: '#1877F2' }}>Facebook skupina</a>}
            <Link to="/shop" style={{ color: 'rgba(255,255,255,0.5)', textDecoration: 'none' }}>Zpět do obchodu</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}

export { C };
